import React from 'react';
import './SocialProofBar.css';

const SocialProofBar: React.FC = () => {
  const stats = [
    { value: '500+', label: 'Zadowolonych uczniow' },
    { value: '98%', label: 'Zdawalnosc matur' },
    { value: '+35pkt', label: 'Sredni wzrost wynikow' },
    { value: '8 tyg', label: 'Do sukcesu' },
  ];

  return (
    <section className="social-proof-bar">
      <div className="social-proof-container">
        {stats.map((stat, index) => (
          <div key={index} className="social-proof-stat">
            <span className="social-proof-value">{stat.value}</span>
            <span className="social-proof-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SocialProofBar;
